import { render, staticRenderFns } from "./SavedContentsTab.vue?vue&type=template&id=34d748ac&scoped=true&"
import script from "./SavedContentsTab.vue?vue&type=script&lang=js&"
export * from "./SavedContentsTab.vue?vue&type=script&lang=js&"
import style0 from "./SavedContentsTab.vue?vue&type=style&index=0&id=34d748ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d748ac",
  null
  
)

export default component.exports